/* eslint-disable no-inline-styles/no-inline-styles */
import { useParams } from 'react-router-dom'
import { Container, IFrameContainer } from './styles'
import { theme } from '@theme/index'
import { Helmet } from 'react-helmet'

export default function Insights() {
  const { id } = useParams()
  const filter = `{"monitorId":{"$eq":ObjectId("${id}")}}`

  return (
    <Container>
      <Helmet>
        <title>Nomos - Monitoramento Insights</title>
      </Helmet>
      <IFrameContainer>
        <iframe
          width="100%"
          height="100%"
          title="Nomos Insights"
          style={{
            margin: '0 6%',
            borderTop: '0px',
            paddingTop: '10px',
            background: 'white',
            borderBottom: '0px',
            borderLeft: `1px solid ${theme.palette['$color-border-secondary']}`,
            borderRight: `1px solid ${theme.palette['$color-border-secondary']}`,
          }}
          src={`https://charts.mongodb.com/charts-nomos-oxgic/embed/dashboards?id=02fe4a4d-9a45-43e7-8ccc-2ebada2d3977&theme=light&autoRefresh=true&maxDataAge=86400&showTitleAndDesc=false&scalingWidth=scale&scalingHeight=fixed&attribution=false&filter=${filter}`}
        />
      </IFrameContainer>
    </Container>
  )
}
